import { TypedUseSelectorHook, useSelector, useDispatch } from "react-redux"
import type { RootState, AppDispatch } from "./store"

// Use throughout your app instead of plain `useSelector`
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppDispatch = () => useDispatch<AppDispatch>()

export const useStore = () => {
  const selector = useAppSelector
  const dispatch = useAppDispatch()

  return { selector, dispatch }
}
